// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Nav Styles */

.anchors {
  display: flex;
  flex-direction: column;
  padding-left: 15px;
  margin-bottom: 5px;
  justify-content: center;
  align-items: left;
  text-decoration: none;
  color: black
}




/* Quotation Mark Styles */

.quotationMark {
  font-size: 100px; 
  color: black;
  line-height: 0.8;
}

.quotationMark2 {
  font-size: 100px; 
  color: blackg;
  line-height: 0.8;
  text-align: right;
}

.text {
  font-size: 30px; 
  font-weight: bold;
  margin: 10px;
}

.offsetText {
  text-align: right;
  margin-right: 10%;
}

/* Element styles */

.selectDropdown {
  width: 100%;
  height: auto;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,eAAe;;AAEf;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;EACvB,iBAAiB;EACjB,qBAAqB;EACrB;AACF;;;;;AAKA,0BAA0B;;AAE1B;EACE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA,mBAAmB;;AAEnB;EACE,WAAW;EACX,YAAY;AACd","sourcesContent":["/* Nav Styles */\n\n.anchors {\n  display: flex;\n  flex-direction: column;\n  padding-left: 15px;\n  margin-bottom: 5px;\n  justify-content: center;\n  align-items: left;\n  text-decoration: none;\n  color: black\n}\n\n\n\n\n/* Quotation Mark Styles */\n\n.quotationMark {\n  font-size: 100px; \n  color: black;\n  line-height: 0.8;\n}\n\n.quotationMark2 {\n  font-size: 100px; \n  color: blackg;\n  line-height: 0.8;\n  text-align: right;\n}\n\n.text {\n  font-size: 30px; \n  font-weight: bold;\n  margin: 10px;\n}\n\n.offsetText {\n  text-align: right;\n  margin-right: 10%;\n}\n\n/* Element styles */\n\n.selectDropdown {\n  width: 100%;\n  height: auto;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
